module.exports = __webpack_public_path__ + "img/iconCheckMarkGreen.5ca26f3a.svg";